function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/* global document, requestAnimationFrame */


import * as React from "react";

var AriaPopup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AriaPopup, _React$Component);

  function AriaPopup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false,
      manageNextFocus: false
    };

    _this.triggerRefFunc = function (ref) {
      _this.trigger = ref;
    };

    _this.popupRefFunc = function (ref) {
      _this.popup = ref;
    };

    _this.onGlobalFocusOrClick = function (_ref) {
      var target = _ref.target;

      if (!_this.state.isOpen || !(target instanceof HTMLElement) || _this.isTargetInTrigger(target) || _this.isTargetInPopup(target)) {
        return;
      }

      _this.setState({
        isOpen: false,
        manageNextFocus: false
      });
    };

    _this.onTriggerClick = function (event) {
      event.preventDefault();

      _this.toggle();
    };

    _this.onKeyDown = function (event) {
      if (event.keyCode === 27) {
        _this.close();
      }
    };

    _this.getTriggerProps = function (_temp) {
      var _ref3;

      var _ref2 = _temp === void 0 ? {} : _temp,
          _ref2$refProp = _ref2.refProp,
          refProp = _ref2$refProp === void 0 ? "ref" : _ref2$refProp;

      return _ref3 = {
        id: _this.props.id,
        onClick: _this.onTriggerClick,
        "aria-haspopup": "true",
        "aria-expanded": _this.state.isOpen ? "true" : "false"
      }, _ref3[refProp] = _this.triggerRefFunc, _ref3;
    };

    _this.getPopupProps = function (_temp2) {
      var _ref5;

      var _ref4 = _temp2 === void 0 ? {} : _temp2,
          _ref4$refProp = _ref4.refProp,
          refProp = _ref4$refProp === void 0 ? "ref" : _ref4$refProp;

      return _ref5 = {
        "aria-labelledby": _this.props.id,
        "aria-hidden": _this.state.isOpen ? "false" : "true",
        role: "region"
      }, _ref5[refProp] = _this.popupRefFunc, _ref5;
    };

    _this.open = function () {
      if (_this.state.isOpen) return;

      _this.setState({
        isOpen: true,
        manageNextFocus: true
      });

      document.addEventListener("focusin", _this.onGlobalFocusOrClick, true);
      document.addEventListener("click", _this.onGlobalFocusOrClick, true);
      document.addEventListener("keydown", _this.onKeyDown, true);
    };

    _this.close = function () {
      if (!_this.state.isOpen) return;

      _this.setState({
        isOpen: false,
        manageNextFocus: true
      });

      _this.removeEventListeners();
    };

    _this.toggle = function () {
      if (_this.state.isOpen) {
        _this.close();
      } else {
        _this.open();
      }
    };

    return _this;
  }

  var _proto = AriaPopup.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(_prevProps, _ref6) {
    var prevIsOpen = _ref6.isOpen;
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        manageNextFocus = _this$state.manageNextFocus;
    if (isOpen === prevIsOpen || !manageNextFocus) return;

    if (isOpen) {
      if (this.props.bringFocusInside) {
        this.bringFocusInside();
      }
    } else {
      this.bringFocusBackToTrigger();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEventListeners();
  };

  _proto.removeEventListeners = function removeEventListeners() {
    document.removeEventListener("focusin", this.onGlobalFocusOrClick, true);
    document.removeEventListener("click", this.onGlobalFocusOrClick, true);
    document.removeEventListener("keydown", this.onKeyDown, true);
  }; // Much of the focus management was taken from:
  // https://github.com/segmentio/evergreen/blob/master/src/popover/src/Popover.js


  _proto.bringFocusInside = function bringFocusInside() {
    var _this2 = this;

    requestAnimationFrame(function () {
      if (!_this2.state.isOpen || _this2.isTargetInPopup(document.activeElement)) {
        return;
      }

      if (_this2.popup == null) return; // Element marked autofocus has higher priority than the other clowns

      var autofocusElement = _this2.popup.querySelector("[autofocus]");

      var wrapperElement = _this2.popup.querySelector("[tabindex]");

      var buttonElements = _this2.popup.querySelectorAll('button, a, [role="menuitem"], [role="menuitemradio"]');

      if (autofocusElement && autofocusElement instanceof HTMLElement) {
        autofocusElement.focus();
      } else if (wrapperElement && wrapperElement instanceof HTMLElement) {
        wrapperElement.focus();
      } else if (buttonElements.length > 0 && buttonElements[0] instanceof HTMLElement) {
        buttonElements[0].focus();
      }
    });
  } // Much of the focus management was taken from:
  // https://github.com/segmentio/evergreen/blob/master/src/popover/src/Popover.js
  ;

  _proto.bringFocusBackToTrigger = function bringFocusBackToTrigger() {
    var _this3 = this;

    requestAnimationFrame(function () {
      if (_this3.trigger && (document.activeElement === document.body || _this3.isTargetInPopup(document.activeElement))) {
        _this3.trigger.focus();
      }
    });
  };

  _proto.isTargetInPopup = function isTargetInPopup(target) {
    return this.popup != null && target != null && this.popup.contains(target);
  };

  _proto.isTargetInTrigger = function isTargetInTrigger(target) {
    return this.trigger != null && target != null && this.trigger.contains(target);
  };

  _proto.render = function render() {
    return this.props.children({
      getTriggerProps: this.getTriggerProps,
      getPopupProps: this.getPopupProps,
      open: this.open,
      close: this.close,
      toggle: this.toggle,
      isOpen: this.state.isOpen
    });
  };

  return AriaPopup;
}(React.Component);

AriaPopup.defaultProps = {
  bringFocusInside: false
};
export { AriaPopup as default };